import React, { useState } from "react";
import { Row, Col, Spin, Upload, notification } from "antd";
import { ImportStyled } from "./styled";
import SvgIcon from "src/components/SvgIcon";
import HRService from "src/services/HumanResource";

const { Dragger } = Upload;

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

const UploadContractModal = ({ open, onCancel, onOk, contractId }) => {
  const [loading, setLoading] = useState(false);

  // Upload file hợp đồng
  const handleUpload = async file => {
    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("file", file);
      formData.append("contractId", contractId);

      // API upload contract scan/pdf
      const response = await HRService.uploadContractFile(formData);

      if (response?.isError) {
        notification.error({
          message: response?.message || "Tải lên thất bại!",
        });
        return;
      }

      notification.success({
        message: "Tải lên hợp đồng thành công!",
        description: file.name,
      });

      onOk?.(response?.data);
      onCancel?.();
    } catch (error) {
      notification.error({
        message: "Có lỗi xảy ra khi tải file!",
        description:
          error?.response?.data?.message || error?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    maxCount: 1,
    accept: ".pdf,.png,.jpg,.jpeg",

    beforeUpload: file => {
      const isValidType =
        file.type === "application/pdf" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";

      if (!isValidType) {
        notification.error({
          message: "Chỉ hỗ trợ file PDF hoặc ảnh scan!",
        });
        return Upload.LIST_IGNORE;
      }

      const isLt10MB = file.size <= MAX_FILE_SIZE;

      if (!isLt10MB) {
        notification.error({
          message: "Dung lượng file tối đa 10MB!",
        });
        return Upload.LIST_IGNORE;
      }

      return true;
    },

    customRequest: async ({ file, onSuccess, onError }) => {
      try {
        await handleUpload(file);

        onSuccess("ok");
      } catch (err) {
        onError(err);
      }
    },

    showUploadList: true,
  };

  return (
    <ImportStyled>
      <Spin spinning={loading}>
        <div style={{ marginBottom: 12 }}>
          Tải lên hợp đồng scan hoặc file PDF đã ký.
        </div>

        <Dragger {...uploadProps}>
          <Row gutter={20} className="justify-content-center">
            <Col>
              <SvgIcon name="cloud" />
            </Col>

            <Col>
              <span>
                Kéo thả file hợp đồng hoặc{" "}
                <span style={{ color: "#154398" }}>
                  Chọn File
                </span>
              </span>

              <div
                style={{
                  marginTop: 8,
                  fontSize: 12,
                  color: "#888",
                }}
              >
                Hỗ trợ: PDF, JPG, PNG (Tối đa 10MB)
              </div>
            </Col>
          </Row>
        </Dragger>

        <Row className="box-note pt-15">
          <Col>
            <SvgIcon name="warningCKS" />
          </Col>

          <Col className="ml-10">
            Lưu ý: Upload hợp đồng đã ký để lưu trữ và đối soát.
          </Col>
        </Row>
      </Spin>
    </ImportStyled>
  );
};

export default UploadContractModal;